// extracted by mini-css-extract-plugin
export default {"doc-link":"bZfzCBBWyl","docLink":"bZfzCBBWyl"};